const Utils = () => {

  const select = (selector) => {
    return document.querySelector(selector)
  }

  const selectAll = (selector) => {
    return document.querySelectorAll(selector)
  }

  const selectForEach = (selector, callback) => {
    const items = document.querySelectorAll(selector)
    if(items && items.length > 0){
      items.forEach((item) => callback(item))
    }
  }

  const enableScroll = () => {
    if(window.pd_smoother){
      window.pd_smoother.paused(false)
    } 
    if(window.lenis){
      window.lenis.start()
    } 
  }

  const disableScroll = () => {
    if(window.pd_smoother){
      window.pd_smoother.paused(true)
    }
    if(window.lenis){
      window.lenis.stop()
    } 
  }

  const debounce = (func, wait) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  };

  const isTouchDevice = () =>  {
    return (('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0));
  }
  
  const tabNavigationHandler = () => {
    function handleFirstTab(e) {
      if (e.keyCode === 9) {
        document.body.classList.add('navigation--keyboard');
        
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
      }
    }
    
    function handleMouseDownOnce() {
      document.body.classList.remove('navigation--keyboard');
      
      window.removeEventListener('mousedown', handleMouseDownOnce);
      window.addEventListener('keydown', handleFirstTab);
    }
    
    window.addEventListener('keydown', handleFirstTab);
  }


  return {
    enableScroll,
    disableScroll,
    debounce,
    select,
    selectAll,
    selectForEach,
    isTouchDevice,
    tabNavigationHandler
  }
}

export const utils = Utils()